export { default as ElementiView } from "./ElementiView";
export { default as ModElementView } from "./ModElementView";
export { default as TemplateAddView } from "./TemplateAddView";
export { default as TemplateModifyView } from "./TemplateModifyView";
export { default as TemplateView } from "./TemplateView";
export { default as MailCareView} from "./MailCareView"
export { default as LoginView } from "./LoginView"
export { default as ImagesView} from "./ImagesView"
